import { css } from '@emotion/react';

const FilterControlsContainerStyle = css`
  display: flex;
  justify-content: space-between;
  padding: 1rem;
`;

export default FilterControlsContainerStyle;
